<template>
  <v-col
    @click="$emit('toggle', field)"
    :class="colClasses"
    :cols="cols"
    :md="md"
    :sm="sm"
  >
    <template v-if="checkable">
      <template v-if="checkLocked">
        <v-checkbox-btn
          @click.stop.prevent.capture="$emit('check')"
          :aria-label="$bct('Select all - locked')"
          :model-value="checkValue"
          class="me-2 pt-0 mt-0 flex-0-0"
          data-testid="select-all"
          readonly
        />
      </template>
      <template v-else>
        <v-checkbox-btn
          v-model="checked"
          @update:model-value="$emit('check')"
          :aria-label="$bct('Select all')"
          class="me-2 pt-0 mt-0 flex-0-0"
          data-testid="select-all"
        />
      </template>
    </template>

    <span
      :aria-sort="ariaSort"
      role="columnheader"
    >
      {{ $bct(title) }}
    </span>

    <v-icon
      v-show="sorted"
      :icon="sortIcon"
      class="ms-1"
      color="black"
      aria-hidden
    />
  </v-col>
</template>

<script setup>
const $bct = inject('translator');

const props = defineProps({
  checkable: {
    type: Boolean,
    default: false,
  },
  checkLocked: {
    type: Boolean,
    default: false,
  },
  checkValue: {
    type: Boolean,
    default: false,
  },
  cols: {
    type: String,
    default: null,
  },
  dense: {
    type: Boolean,
    default: false,
  },
  disableSort: {
    type: Boolean,
    default: false,
  },
  field: {
    type: String,
    default: null,
  },
  horizontalAlign: {
    type: String,
    default: null,
  },
  md: {
    type: String,
    default: null,
  },
  sm: {
    type: String,
    default: null,
  },
  sortDir: {
    type: String,
    default: null,
  },
  sortField: {
    type: String,
    default: null,
  },
  title: {
    type: String,
    default: null,
  },
});

defineEmits(['check', 'toggle']);

const checked = ref(false);

const ariaSort = computed(() => {
  if (sorted.value) {
    return props.sortDir === 'asc' ? 'ascending' : 'descending';
  }
  return null;
});

const colClasses = computed(() => {
  const classes = 'fw-600 c-black align-center'.split(' ');

  classes.push(props.dense ? 'fs-14' : 'fs-16');

  if (props.field) classes.push('pointer');

  switch (props.horizontalAlign) {
    case 'center':
      classes.push('d-flex-center', 'd-none', 'd-md-flex');
      break;
    case 'right':
      classes.push('justify-end', 'd-none', 'd-md-flex');
      break;
    default:
      classes.push('d-none', 'd-md-flex');
      break;
  }

  return classes.join(' ');
});

const sorted = computed(() => {
  return props.field && props.sortField === props.field;
});

const sortIcon = computed(() => {
  if (sorted.value) {
    return props.sortDir === 'asc' ? 'arrow_drop_up' : 'arrow_drop_down';
  }
  return null;
});

const check = (newVal) => {
  checked.value = newVal;
};

defineExpose({
  check,
});
</script>
